// ============================================================================
// useRecsuitPermissions
// ============================================================================
// Recsuit role-based permission hook (Phase 4). Returns the engine built from
// the user's `resource_access.recsuit.roles[]` JWT claim merged with the
// catalog row in `admin.tbl_role`. Used by:
//
//   - <RecsuitPermissionGate module=… action=…> for declarative gating
//   - sidebar nav builder to hide invisible modules
//   - guard logic before navigating to a screen
//
// Coexists with `usePermissions()` which talks to the legacy tenant-hub model.

import { useAuthContext } from '../contexts/AuthContext';
import type { RecsuitRoleEngine } from '../auth/recsuitRoleEngine';

export const useRecsuitPermissions = (): RecsuitRoleEngine => {
  const { recsuitRoleEngine } = useAuthContext();
  return recsuitRoleEngine;
};

export default useRecsuitPermissions;
